<template>	   
	<v-container>
			<material-card
			  class="card-tabs" title="Registrar nuevo usuario"
          text="Da de alta un usuario dentro de la plataforma"
			  color="green">
			  <v-card>
			    <v-card-text>	
			    	<v-layout row justify-center wrap>
			    	  <v-flex xs10 offset-1>
								<v-text-field solo
		    	  	    name="name"
		    	  	    label="Nombre"
		    	  	    id="name" v-model="user.name"
		    	  	  ></v-text-field>
		    	  	  <v-text-field solo
		    	  	    name="email" type="email"
		    	  	    label="Correo electronico"
		    	  	    id="email" v-model="user.email"
		    	  	  ></v-text-field>
		    	  	  <v-text-field solo
		    	  	    name="rol"
		    	  	    label="Permisos"
		    	  	    id="rol" v-model="user.rol"
		    	  	  ></v-text-field>
			    	  </v-flex>	
			    	</v-layout>
			    </v-card-text>
			    <v-card-actions>
			      <v-btn color="success" @click="store()">Guardar</v-btn>
			    </v-card-actions>
			  </v-card>
			</material-card>
			<v-snackbar :color="alert.color"
			  v-model="alert.active"
			>
			  {{ alert.messague }}
			  <v-btn text  @click.native="alert.active = false">Close</v-btn>
			</v-snackbar>
	</v-container>
</template>
<script>
	export default{
		created() {

		},
		mounted(){

		},
		props: [
			
		],
		data(){
			return {
				basePath: process.env.VUE_APP_URL + 'api/user/',
				user: {
					name: '',
					email: '',
					rol: '',
					password: '1235678',
					c_password: '12345678'
				},
				alert: {
					active: false,
					messague: '',
					color: '',
				}
			}
		},
		methods: {
			store(){
				axios.post(this.basePath + 'store', this.user).then((res) => {
					this.$router.push('/admin/create');
				}).catch((error) =>{

				});	
			}
		},	
		watch: {

		},
		computed: {

		},
	}
</script>